import { Button, SpinningLoader } from "risa-oasis-ui_v2";
import { NarIngestionStatus } from "../../../../../enums/narIngestionStatus";
import { CrossIcon } from "../../../../../svg/cross-icon";
import DownloadIcon from "../../../../../svg/download-icon";
import WarningIcon from "../../../../../svg/warningIcon";

interface RenderActionButtonsProps {
  onApprove?: () => void;
  onReject?: () => void;
  onUpload?: () => void;
  onDownload?: () => void;
  onRetry?: () => void;
  onDelete?: () => void;
  isApproving?: boolean;
  isRejecting?: boolean;
  isRejected?: boolean;
}

export const getRenderActionButtons = ({
  onApprove,
  onReject,
  onUpload,
  onDownload,
  onRetry,
  onDelete,
  isApproving = false,
  isRejecting = false,
  isRejected = false,
}: RenderActionButtonsProps) => {
  const renderActionButtons = (status: string): JSX.Element => {
    switch (status) {
      case NarIngestionStatus.HumanInTheLoop:
        return (
          <>
            <Button
              buttonType="secondary"
              size="medium"
              onClick={onApprove ?? (() => {})}
              disabled={isApproving || isRejected}
            >
              Approve
            </Button>
            <Button
              buttonType="primary"
              size="medium"
              onClick={onUpload ?? (() => {})}
              disabled={false}
            >
              Upload
            </Button>
            <div onClick={onDownload ?? (() => {})}>
              <DownloadIcon />
            </div>
            <div
              className={isRejected ? "" : "cursor-pointer"}
              onClick={
                onReject && !isRejected && !isRejecting ? onReject : undefined
              }
              title={isRejected ? "Already rejected" : "Reject"}
            >
              <CrossIcon
                height="24"
                width="24"
                fillColor={isRejected ? "#999" : "#000"}
              />
            </div>
          </>
        );

      case NarIngestionStatus.Completed:
        return (
          <>
            <div onClick={onDownload ?? (() => {})}>
              <DownloadIcon />
            </div>
          </>
        );

      case NarIngestionStatus.InProgress:
        return (
          <>
            <div className="flex flex-row items-center gap-2">
              <SpinningLoader />
              <div className="text-sm">In Progress...</div>
            </div>
          </>
        );

      case NarIngestionStatus.Error:
        return (
          <>
            <WarningIcon height="24" width="24" />
          </>
        );

      case NarIngestionStatus.ToDo:
        return (
          <>
            <div className="text-sm">To Do...</div>
          </>
        );

      default:
        return <></>;
    }
  };

  return { renderActionButtons };
};
